import { DataUsageRounded, FolderRounded, LocalOfferRounded, ScheduleRounded, TodayRounded } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { MoreInfoDetail, MoreInfoDetailItem } from '../../backoffice/library/models/resource'
import { DetailContainer, Text } from '../styles/DetailPanelStyle'

function DetailInfoPanel({ attributes }: { attributes: MoreInfoDetail }) {
  const { t } = useTranslation(['global'])

  const icons: any[string] = []
  icons['tag'] = <LocalOfferRounded fontSize="large" />
  icons['file'] = <FolderRounded fontSize="large" />
  icons['time'] = <ScheduleRounded fontSize="large" />
  icons['size'] = <DataUsageRounded fontSize="large" />
  icons['date'] = <TodayRounded fontSize="large" />

  const typeDetail = (type: string) => icons[type]
  return (
    <DetailContainer className="info">
      <Box width="100%">
        <Typography variant="subtitle1" sx={theme => ({ fontWeight: 500, color: theme.palette.grey[600] })}>
          {t('additional-information')}
        </Typography>
      </Box>
      <Box display="flex" gap={2} flexDirection="column" width="100%">
        {attributes.item.map((item: MoreInfoDetailItem) => (
          <Box display="flex" gap={1} flexDirection="row" width="100%" key={item.id}>
            <Text className={item.color}>{typeDetail(item.type)}</Text>
            <Box display="flex" flexDirection="column" width="100%">
              <Text className={item.color}>{item.title}</Text>
              <Typography variant="body2" color="textSecondary">
                {item.info}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </DetailContainer>
  )
}

export default DetailInfoPanel
